import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/upload-03.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12ZM11 16V10.4141L8.70703 12.707C8.31651 13.0976 7.68349 13.0976 7.29297 12.707C6.90244 12.3165 6.90244 11.6835 7.29297 11.293L11.293 7.29297L11.3691 7.22461C11.7619 6.90426 12.3409 6.92685 12.707 7.29297L16.707 11.293L16.7754 11.3691C17.0957 11.7619 17.0731 12.3409 16.707 12.707C16.3409 13.0731 15.7619 13.0957 15.3691 12.7754L15.293 12.707L13 10.4141V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as Upload03Icon };
